<template lang="pug">
    lairdnd-reset-password(
        :settings="settings"
        :translations="translations"
        :token="$route.query.token"
        :email="$route.query.email"
    )
</template>

<script>
export default {
    name: 'reset-password-page',

    data() {
        return {
            settings: {
                form: {
                    fields: {
                        email: {
                            show: false,
                            validations: false,
                        },
                    },
                },
            },
            translations: {
                title: 'Create new password',
                notice: 'Your new password must be different from previously used passwords.',
                submitButtonTitle: 'Create',
            },
        }
    },
}
</script>
